import { Box, Image, Text, Button, Fade } from "@chakra-ui/react";
import ReferenceTable from "./referenceTable";

function DisplayImage(props) {
  return (
    <>
      {props.inputImage === null ? (
        <Box></Box>
      ) : (
        <>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-around'
            flexDirection={{ base: "column", md: "row", xl: "row" }}
            width='70%'
          >
            <Fade in={!!props.inputImage}>
              <Box mb={5} textAlign='center'>
                <Text
                  fontFamily='Fjord One'
                  fontSize={{ base: "md", md: "lg", xl: "xl" }}
                  fontWeight={600}
                  color='white'
                >
                  Uploaded Image
                </Text>
                <Image
                  src={`data:image/png;base64,  ${props.inputImage}`}
                  borderRadius={4}
                  boxSize={{ base: "100%", md: "100%", xl: "100%" }}
                />
              </Box>
            </Fade>
            <Fade in={!!props.outputImage}>
              <Box pt={5} textAlign='center'>
                <Text
                  color='white'
                  fontFamily='Fjord One'
                  fontSize={{ base: "md", md: "lg", xl: "xl" }}
                  fontWeight={600}
                  mx='auto'
                >
                  Masked Image
                </Text>

                <Image
                  src={`data:image/png;base64,  ${props.outputImage}`}
                  borderRadius={4}
                  boxSize={{ base: "83%", md: "73%", xl: "68.45%" }}
                  mx='auto'
                />
                <Button mt={2} mb={2}>
                  <a
                    download
                    href={`data:image/png;base64,  ${props.outputImage}`}
                  >
                    Download Masked Image
                  </a>
                </Button>
              </Box>
            </Fade>
          </Box>
          <Text
            fontFamily='Fjord One'
            fontSize={{ base: "md", md: "lg", xl: "xl" }}
            fontWeight={600}
            color='white'
          >
            Score: {props.score}
          </Text>
          <Text
            fontFamily='Fjord One'
            fontSize={{ base: "md", md: "lg", xl: "xl" }}
            fontWeight={600}
            color='white'
          >
            (If you are using mobile or can't see the full table, please scroll
            left or right)
          </Text>
          <ReferenceTable />
        </>
      )}
    </>
  );
}

export default DisplayImage;
